/** Preserve user-owned Drive link fields when applying sync API frontmatter patches. */
export function mergeGdocSyncFrontmatter(
  current: Record<string, unknown> | null | undefined,
  fromSync: Record<string, unknown>,
): Record<string, unknown> {
  const base = current || {}
  const merged = { ...base, ...fromSync }
  if (fromSync.gdoc_sync_mode == null && base.gdoc_sync_mode != null) {
    merged.gdoc_sync_mode = base.gdoc_sync_mode
  }
  if (fromSync.gdoc_linked_by == null && base.gdoc_linked_by != null) {
    merged.gdoc_linked_by = base.gdoc_linked_by
  }
  return merged
}
